import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const Container = styled(Box)`
  flex: 1;
  width: 100%;
  margin: 0 auto;
  padding: 0 70px;
  text-align: center;
`;

export const StepContent = styled(Box)`
  margin: 30px 0;
`;

export const OptionWrapper = styled(Box)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 1fr;
  gap: 40px;

  button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 30px;
    font-size: 1rem;
    width: 100%;
    gap: 0;
    line-height: 1;
  }
`;

export const ButtonContainer = styled(Box)(
  ({ theme }) => `
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 15px 25px;
  gap: 10px;
  border-top: 1px solid ${theme.palette.divider};
`,
);
